'use es6';

import { LayoutWithCollaborationSidebar, SUPPORTED_HUBS, CommentObjectType, FEATURES } from 'collaboration-sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardCollaborationSidebar = ({
  children,
  dashboardId
}) => {
  const embeddedCommentsProps = {
    appSupportedRoutesRegex: /\/reports-dashboard\/[0-9]+\/view\/[0-9]+\/?/
  };
  return /*#__PURE__*/_jsx(LayoutWithCollaborationSidebar, {
    objectId: dashboardId.toString(),
    objectType: CommentObjectType.REPORTING_DASHBOARD,
    appName: "DashboardUI",
    appHub: Object.values(SUPPORTED_HUBS),
    enabledFeatures: [FEATURES.DEEP_COMMENTING, FEATURES.COMMENTS],
    scrollablePage: true,
    embeddedCommentsProps: embeddedCommentsProps,
    children: children
  }, dashboardId);
};
export default DashboardCollaborationSidebar;